export default "__VITE_ASSET__C_6SyR4K__"